import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import RoleViewPage from "./pages/RoleViewPage.vue";
import RoleCreatePage from "./pages/RoleCreatePage.vue";
import RoleUpdatePage from "./pages/RoleUpdatePage.vue";

export const RoleRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "role"
) => [
  {
    name: "RoleViewPage",
    path: prefix,
    component: RoleViewPage,
    meta: { title: "Role List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.ROLE_VIEW)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "RoleCreatePage",
    path: `${prefix}/create`,
    component: RoleCreatePage,
    meta: { title: "Create New Role" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.ROLE_CREATE)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "RoleEditPage",
    path: `${prefix}/edit/:id`,
    component: RoleUpdatePage,
    meta: { title: "Edit Role" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.ROLE_EDIT)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
